function updateDocumentTitle(title) {
    document.title = title + ' | Contract Well | Legal Contract Templates';
}

export default updateDocumentTitle;